"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CwOrderedListOption = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwOrderedList = _interopRequireDefault(require("./CwOrderedList.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactSmoothDnd = require("react-smooth-dnd");

var _CwLabel = _interopRequireDefault(require("../../components/cwlabel/CwLabel"));

var CwOrderedList =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwOrderedList, _React$Component);

  function CwOrderedList(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CwOrderedList);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf3.default)(CwOrderedList).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDrop", function (_ref) {
      var addedIndex = _ref.addedIndex,
          removedIndex = _ref.removedIndex,
          payload = _ref.payload;
      var options = (0, _toConsumableArray2.default)(_this.props.options);

      if (removedIndex !== null && removedIndex !== undefined) {
        options = options.filter(function (x) {
          return !payload.find(function (p) {
            return p.id === x.id;
          });
        });
      }

      if (addedIndex !== null && addedIndex !== undefined && payload) {
        var _options;

        (_options = options).splice.apply(_options, [addedIndex, 0].concat((0, _toConsumableArray2.default)(payload)));
      }

      _this.handleChange(options);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "shouldAcceptDrop", function (sourceContainerOptions, payload) {
      var isSource = sourceContainerOptions.id === _this.state.dropContainerId;
      return sourceContainerOptions.groupName === _this.props.groupName && (isSource || !payload.find(function (x) {
        return x.locked;
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onOptionClick", function (option, ctrlKey) {
      var options = (0, _toConsumableArray2.default)(_this.props.options);
      options.forEach(function (x) {
        if (x.id === option.id) {
          x.selected = !option.selected;
        } else if (!ctrlKey) {
          x.selected = false;
        }
      });

      _this.handleChange(options);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPayload", function (index) {
      var selected = _this.props.options.filter(function (x) {
        return x.selected;
      });

      var dragSelection = _this.props.options[index];
      return selected.includes(dragSelection) ? selected : selected.concat(dragSelection);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (options) {
      if (_this.props.onChange) {
        _this.props.onChange(options);
      }
    });
    _this.state = {
      dropContainerId: Math.random()
    };
    return _this;
  }

  (0, _createClass2.default)(CwOrderedList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var options = props.options.map(function (option) {
        return _react.default.createElement(CwOrderedListOption, {
          key: option.id,
          value: option,
          onClick: _this2.onOptionClick
        });
      });
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(_CwOrderedList.default.wrap, props.className),
        "data-cwid": props.cwId
      }, _react.default.createElement(_CwLabel.default, {
        value: props.listHeader,
        className: _CwOrderedList.default.header
      }), _react.default.createElement("div", {
        className: _CwOrderedList.default.list,
        tabIndex: "0",
        onFocus: props.onFocus,
        onBlur: props.onBlur
      }, props.disabled ? options : _react.default.createElement(_reactSmoothDnd.Container, {
        id: this.state.dropContainerId,
        style: {
          height: "100%",
          width: "100%"
        },
        dropPlaceholder: {
          className: _CwOrderedList.default.dropPreview,
          animationDuration: 150,
          showOnTop: true
        },
        onDrop: this.onDrop,
        groupName: props.groupName,
        getChildPayload: this.getPayload,
        shouldAcceptDrop: this.shouldAcceptDrop
      }, options)));
    }
  }]);
  return CwOrderedList;
}(_react.default.Component);

var CwOrderedListOption =
/*#__PURE__*/
function (_React$Component2) {
  (0, _inherits2.default)(CwOrderedListOption, _React$Component2);

  function CwOrderedListOption() {
    var _getPrototypeOf2;

    var _this3;

    (0, _classCallCheck2.default)(this, CwOrderedListOption);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this3 = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CwOrderedListOption)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "handleClick", function (event) {
      _this3.props.onClick(_this3.props.value, event.ctrlKey);
    });
    return _this3;
  }

  (0, _createClass2.default)(CwOrderedListOption, [{
    key: "render",
    value: function render() {
      var value = this.props.value;
      return _react.default.createElement(_reactSmoothDnd.Draggable, null, _react.default.createElement("div", {
        className: (0, _classnames.default)(_CwOrderedList.default.option, value.selected ? _CwOrderedList.default.selected : null),
        onClick: this.handleClick
      }, value.name));
    }
  }]);
  return CwOrderedListOption;
}(_react.default.Component);

exports.CwOrderedListOption = CwOrderedListOption;
CwOrderedList.propTypes = {
  /**
   * Array of options to be listed in the dropdown menu. Must contain at least "id" and "name" fields.
   */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.any,
    name: _propTypes.default.string,
    selected: _propTypes.default.bool,

    /**
     * Indicates that the item should not be draggable to other lists
     */
    locked: _propTypes.default.bool
  })).isRequired,

  /**
   * Callback function that is fired when selection changes
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function that is fired when focused
   */
  onFocus: _propTypes.default.func,

  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Header to display above the list box
   */
  listHeader: _propTypes.default.string,

  /**
   * Group name for drag-and-drop functionality.
   * Use the same group name on multiple drag-and-drop containers
   * to allow dragging between
   */
  groupName: _propTypes.default.string
};
CwOrderedList.defaultProps = {
  options: []
};
var _default = CwOrderedList;
exports.default = _default;